import React from "react";
import "./Pricing.scss";

const Pricing = ({ title, data, dynamicSizes }) => (
  <div className="pricing">
    <p>{title}</p>
    {dynamicSizes ? (
      <table cellSpacing={0}>
        <thead>
          <tr>
            <th className="th"></th>
            {dynamicSizes.map((s, i) => (
              <th className="th" key={i}>
                <p>{s.label}</p>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((d, i) => (
            <tr key={i}>
              <td>{d.label}</td>
              <td>{d.price0}</td>
              <td>{d.price1}</td>
              <td>{d.price2}</td>
              <td>{d.price3}</td>
            </tr>
          ))}
        </tbody>
        <br />
      </table>
    ) : (
      <table cellSpacing={0}>
        <tbody>
          {data.map((d, i) => (
            <tr key={i}>
              <td>{d.label}</td>
              <td>{d.price}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export default Pricing;



// WEBPACK FOOTER //
// ./src/components/ui/Pricing/Pricing.js